<template>
  <div
    id="app"
    :class="appClass"
  >
    <header-claro v-if="useHeader" />

    <div class="app__content">
      <router-view />
    </div>

    <g-tag-manager :google-tag-id="googleTagId" />
  </div>
</template>

<script>
import storage from '@lagersoft/key-storage';
import { mapActions, mapGetters } from 'vuex';
import {
  MPC,
  MCA,
  MCE,
  GTAG_MANAGER
} from '@/utils/constants';
import getUrlParams from '@/utils/getUrlParams';
import GTagManager from '@/components/GTagManager';

export default {
  name: 'Home',
  components: {
    GTagManager
  },
  data() {
    return {
      appClass: MPC,
      useHeader: true
    };
  },
  computed: {
    ...mapGetters(['country', 'app']),
    googleTagId() {
      return GTAG_MANAGER[this.country.pais].code;
    }
  },
  created() {
    this.setMpcToken();
    this.setClassAndApp();
  },
  methods: {
    ...mapActions(['setApp', 'setCountry', 'setPhone', 'setInvoices']),
    setMpcToken() {
      if (getUrlParams('t') && !storage.get('tokenIvr')) {
        const token = getUrlParams('t');
        storage.set('tokenIvr', token);
      }
    },
    setClassAndApp() {
      const isMCE = getUrlParams('app') === MCE;
      const isMCA = window.location.href.includes('mispagosclaro')
        || window.location.href.includes('claropayment')
        || getUrlParams('app') === 'mca';

      const app = isMCE ? MCE : isMCA ? MCA : MPC;
      this.appClass = app.toLowerCase();
      this.setApp(app);

      if (isMCA || isMCE) this.useHeader = false;
    }
  }
};
</script>

<style lang="scss">
#app {
  margin: 0;
  background-image: url("../img/claro_watermark2.png");
  background-repeat: no-repeat;
  background-position: bottom left;
  background-attachment: fixed;
  background-size: 200px;
  min-height: 100vh;
}

.app__content {
  padding: 0 15px 3rem 15px;
  max-width: 630px;
  margin: 0 auto;
}
</style>
